<template>
  <ais-instant-search
    :search-client="searchClient"
    :index-name="playlistIndex"
    class="learning-paths-carousel"
    v-if="resultsFound > 0"
  >
    <ais-hits>
      <swiper
        slot-scope="{ items }"
        class="swiper-container"
        :options="swiperOption"
        :style="resultsFound < 5 ? 'background-color: transparent;' : ''"
      >
        {{ handleResults(items.length) }}
        <swiper-slide
          v-for="path in items"
          :key="path.id"
          class="swiper-slide"
          :style="resultsFound < 5 ? 'background-color: #262626;' : ''"
        >
          <LearningPathTile
            :key="path.id"
            :path="path"
            :backgroundImg="$getPlaylistBackground(path.id)"
            :gradient="$getGradient()"
            :duration="path.duration"
            :difficulty="
              path.difficulty && path.difficulty[0]
                ? path.difficulty[0].rating
                : 0
            "
          />
        </swiper-slide>
        <div
          class="swiper-button-prev"
          style="background: none;"
          :style="resultsFound < 5 ? 'display: none !important' : ''"
          slot="button-prev"
        >
          <i class="material-icons left-advance-carousel"
            >keyboard_arrow_left</i
          >
        </div>
        <div
          class="swiper-button-next"
          style="background: none; right: 40px !important;"
          :style="resultsFound < 5 ? 'display: none !important' : ''"
          slot="button-next"
        >
          <i class="material-icons right-advance-carousel"
            >keyboard_arrow_right</i
          >
        </div>
      </swiper>
    </ais-hits>
    <ais-configure
      :filters="`'categories.name':${JSON.stringify(currentCategory)}`"
    />
  </ais-instant-search>
</template>

<script>
import algoliasearch from 'algoliasearch/lite'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import LearningPathTile from '@/components/layout/LearningPathTile.vue'

export default {
  data() {
    return {
      searchClient: algoliasearch(
        process.env.VUE_APP_ALGOLIA_APP_ID,
        process.env.VUE_APP_ALGOLIA_APP_KEY
      ),
      playlistIndex: process.env.VUE_APP_ALGOLIA_PLAYLISTS_INDEX,
      swiperOption: {
        slidesPerView: 'auto',
        spaceBetween: 5,
        freeMode: true,
        loop: false,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
          disabledClass: 'swiper-button-disabled',
        },
      },
      resultsFound: 1,
    }
  },
  props: {
    currentCategory: {
      type: String,
      required: true,
    },
  },
  components: {
    swiper,
    swiperSlide,
    LearningPathTile,
  },
  methods: {
    handleResults(length) {
      this.resultsFound = length
      this.$emit('resultsFound', length)
    },
  },
}
</script>

<style lang="scss">
.learning-paths-carousel {
  min-width: 96vw;
  .swiper-container {
    background-color: var(--light-gray);
    height: 305px;
  }
  .swiper-slide {
    max-width: 100%;
    @include tablet {
      max-width: 50%;
    }
    @include desktop {
      max-width: 23.5%;
    }
    @include lg-desktop {
      max-width: 15%;
    }
    padding: 5px 3px;
    min-height: 360px;
  }
  .learning-path-tile__details {
    height: 83%;
  }
}
</style>
